'use client';

import { faArrowDown } from '@fortawesome/pro-light-svg-icons';
import { DataTestIdEnum } from '@medprev-web-app/datatestid';

import { Button } from '@/components/ui/button/button.component';
import { scrollToEntityProcedureSection } from '@/app/(main)/(pages)/_components/entities/entity-procedure/_utils/scroll-to-entity-procedure-section.util';

interface EntityProcedureAnchorButtonProps {
  'className'?: string;
  'label'?: string;
  'data-analytics-event'?: string;
}

export function EntityProcedureAnchorButton({
  className,
  label = 'Consultas e horários',
  'data-analytics-event': dataAnalyticsEvent,
}: EntityProcedureAnchorButtonProps) {
  return (
    <Button
      startIcon={faArrowDown}
      className={className}
      onClick={scrollToEntityProcedureSection}
      data-testid={DataTestIdEnum.ENTITY_PROCEDURE_SECTION_ANCHOR_BUTTON}
      data-analytics-event={dataAnalyticsEvent}
    >
      {label}
    </Button>
  );
}
